import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/city/`,
  detail: (id) => `${BASE_URL}/api/v1/city/${id}/`,
  history: (id) => `${BASE_URL}/api/v1/city/${id}/history/`,
};

export const cityListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);
export const cityDetailLoad = (token, { id }) => api.DetailLoad(endpoints.detail, token, { id });
export const cityUpdate = (token, data) => api.Update(endpoints.list, endpoints.detail, token, data);
export const cityDelete = (token, data) => api.Delete(endpoints.detail, token, data);
export const cityHistoryLoad = (token, payload) => api.DetailLoad(endpoints.history, token, { id: payload.id });


export const city = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Города',
    urls: {
      list: () => `/city`,
      detail: (id) => `/city/${id}`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'city', cityListLoad)
    },

    async detailLoad(payload, rootState) {
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'city', cityDetailLoad)
    },

    async update(payload, rootState) {
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'city', cityUpdate);
    },

    async delete(payload, rootState) {
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'city', cityDelete);
    },
  }),
}